<template>
    <menu :class="ballClass" v-if="loaded && ready"  >


      <div class="menu-bar">

        <!-- div class="menu-cta-overlay" :class="ballClass"></div -->
        <div class="menu-cta-overlay2" :class="ballClass"></div>
      </div>
      <div class="menu-over-media" v-if="loaded && ballClass === 'open'" :class="inover" style="transform: translate3d(0,0,0)!important;">
        <media-type v-if="!isMobile" :className="'work-over'" :obj="menuData.work.media" :dynAlt="'NOSSA Work'"></media-type>
        <media-type v-if="isMobile" :className="'work-over'" :obj="menuData.work.media_mob" :dynAlt="'NOSSA  Work'"></media-type>

        <media-type v-if="!isMobile" :className="'about-over'" :obj="menuData.about.media" :dynAlt="'NOSSA About'"></media-type>
        <media-type v-if="isMobile" :className="'about-over'" :obj="menuData.about.media_mob" :dynAlt="'NOSSA About'"></media-type>

        <media-type v-if="!isMobile" :className="'brands-over'" :obj="menuData.work.media" :dynAlt="'NOSSA Brands'"></media-type>
        <media-type v-if="isMobile" :className="'brands-over'" :obj="menuData.work.media_mob" :dynAlt="'NOSSA Brands'"></media-type>

        <media-type v-if="!isMobile" :className="'culture-over'" :obj="menuData.culture.media" :dynAlt="'NOSSA Cultura'"></media-type>
        <media-type v-if="isMobile" :className="'culture-over'" :obj="menuData.culture.media_mob" :dynAlt="'NOSSA  Cultura'"></media-type>

        <media-type v-if="!isMobile" :className="'contact-over'" :obj="menuData.contact.media" :dynAlt="'NOSSA  Contacto'"></media-type>
        <media-type v-if="isMobile" :className="'contact-over'" :obj="menuData.contact.media_mob" :dynAlt="'NOSSA  Contacto'"></media-type>



      </div>

      <div class="menu-bar">

        <!--div class="log" v-if="dev">{{ msg }}</div-->

        <div class="menu-cta-label" :class="ballClass" v-on:mouseover="overBall" v-on:mouseout="outBall"  v-on:click="openMenu">menu</div>
        <div class="close-cta-label" :class="closeClass" v-on:mouseover="overClose" v-on:mouseout="outClose"  v-on:click="closeMenu">


        <span v-if="lang == 0">fechar</span>
        <span v-if="lang == 1">close</span>
        </div>
        <a href="javascript:void(0);"  v-on:click="goPage(0)">  <Icons :id="'NOSSA'"></Icons></a>


        <div class="translator-nhes menu-cta-label " :class="ballClass" >

          <span class="bt-lang" :class="{'active' : lang === 0}" v-on:click="changLang(0);">PT</span>
          <span class="bt-lang" :class="{'active' : lang === 1}" v-on:click="changLang(1);">EN</span>

        </div>
      </div>




        <div class="content-menu" :class="{'open' : ballClass === 'open' && closeClass === 'open'}"  v-if="loaded">
            <!-- div class="items">
                <a v-for="(label, index) in labels.menu" href="javascript:void(0);" v-on:click="changePage(index)" v-on:mouseover="overMenu(index, $event)" v-on:mouseout="outMenu()">{{label[labels.lang]}}</a>


            </div-->

          <a href="javascript:void(0);" :class="{'isopen' : finishOpen}" class="content-menu-item menu-about" v-on:mouseover="overMain('about', 'none')" v-on:mouseout="outMain('none')" v-on:click="goPage(1)"> <span>{{menuData.about.label[lang].name}}</span></a><br>
          <a href="javascript:void(0);" :class="{'isopen' : finishOpen}" class="content-menu-item menu-brands" v-on:mouseover="overMain('brands', 'none')" v-on:mouseout="outMain('none')" v-on:click="goPage(2)"> <span>{{menuData.brands.label[lang].name}}</span></a><br>

          <div class="content-menu-box-ideas">

            <a href="javascript:void(0);" :class="{'isopen' : finishOpen}" class="content-menu-item menu-work" v-on:mouseover="overMain('work', sub)" v-on:mouseout="outMain(sub)" v-on:click="goPage(3)">

              <span>{{menuData.work.label[lang].name}}</span>

              <div class="ideas-box">

                <div class="ideas-box-item" v-for="(item, index) in tags"  v-on:mouseover="overMain('work', item.name[lang].name, sub)" v-on: v-on:mouseout="outMain('none')" v-on:click="goPage(3,item.name[lang].name )" ><span >{{item.name[lang].name}}</span></div>

              </div>
            </a>

           <div class="btn" v-if="isMobile" v-on:click="toogleSub" :class="[opensub, plusvis]"></div>
            <div class="ideas-box-mob" :class="opensub">

              <div class="ideas-box-item" v-for="(item, index) in tags"   v-on:mouseover="overMain('work', item.name[lang].name, sub)" v-on: v-on:mouseout="outMain('none')" v-on:click="goPage(3,item.name[lang].name )" ><span >{{item.name[lang].name}}</span></div>

            </div>

          </div>




          <a href="javascript:void(0);" :class="{'isopen' : finishOpen}" class="content-menu-item menu-culture" v-on:mouseover="overMain('culture', 'none')" v-on:mouseout="outMain('none')" v-on:click="goPage(4)"> <span>{{menuData.culture.label[lang].name}}</span></a><br>
          <a href="javascript:void(0);" :class="{'isopen' : finishOpen}" class="content-menu-item menu-contact" v-on:mouseover="overMain('contact', 'none')" v-on:mouseout="outMain('none')" v-on:click="goPage(5)"> <span>{{menuData.contact.label[lang].name}}</span></a>




          <div class="content-menu-item-line"></div>


          <div class="menu-social" >
            <a href="https://www.facebook.com/NOSSA.agencia.publicidade" target="_blank" class="menu-social-ico menu-social-ico1"><Icons :id="'facebook'"></Icons></a>
            <a href="https://www.linkedin.com/company/NOSSA-/mycompany/" target="_blank" class="menu-social-ico menu-social-ico2"><Icons :id="'linkdin'"></Icons></a>
            <a href="https://www.instagram.com/NOSSA.oficial/" target="_blank" class="menu-social-ico menu-social-ico3"><Icons :id="'instagram'"></Icons></a>
            <a href="https://vimeo.com/NOSSAvideo" target="_blank" class="menu-social-ico menu-social-ico4"> <Icons :id="'vimeo'"></Icons></a>
            <a href="https://www.behance.net/NOSSAtmdes94f4" target="_blank" class="menu-social-ico menu-social-ico5"><Icons :id="'behance'"></Icons></a>

          </div>

        </div>







      <div class="translator" style="display: none;">

        <div class="bt-lang" :class="{'active' : lang === 0}" v-on:click="changLang(0);">PT</div>
        <div class="bt-lang" :class="{'active' : lang === 1}" v-on:click="changLang(1);">EN</div>

      </div>




      <div class="no-click" v-if="noclick"> </div>



    </menu>
</template>

<script>



    import Icons from "./Modules/Icons";
    let menuState = 0;

    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../main';
    import MediaType from "./Modules/MediaType";


    export default {

        name: 'menu-nossa',
      components: {MediaType, Icons},
      props: ['actRoute', 'isMobile', 'lang'],
        watch: {
            'actRoute': function (){




            }
        },
        data() {
            return {
                open: '',
                routes: ['/', '/agency', '/brands', '/ideas', '/people', '/contact'],

                menuData: [],
              tags: [],
              loaded: false,
              ready: false,
              ballClass: '',
              closeClass: '',
              inover: '',

              finishOpen: false,
              msg: 'h',
              dev: true,
              noclick: false,
              sub: 'none',
              opensub: '',
              plusvis: '',
              langs : ['pt', 'en'],
            }
        },

        created() {

          const _this = this;

          WP('menu', function (response){
            console.log(response)

            _this.menuData = response[0];


            WP('tags', function (response2){
              _this.tags = response2;
              _this.loaded = true;
            });

            console.log( _this.menuData)
          });



          if( window.location.host == 'sitedev.nossa.pt'){

            this.dev = false;
          }
          EVENTBUS.$on('log', this.log);

        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);
            //console.log(this.labels)
//


          //  EVENTBUS.$on('showMenu', this.showMenu);


          this.ready = true;


        },

        destroyed() {

        },




        methods: {





          log(m){
            this.msg = m;
          },

          changLang(n){
            EVENTBUS.$emit('changLang', n);

            const url = new URL(window.location);

            url.searchParams.set('lang',this.langs[n]);
            window.history.pushState({}, '', url);
          },







            blockMemu() {
                $('.menu-mot').css('pointer-events', 'none');

                setTimeout(function () {
                    $('.menu-mot').css('pointer-events', 'auto');
                }, 3000);
            },

            showMenu(b) {


               // BackgroundCheck.refresh();


                if(b){
                    TweenMax.to($('.logo-menu'), 0.5, {
                        transform: 'translateZ(0) translateY(0px)',
                        ease: Power2.easeOut} );

                    TweenMax.to($('.hamburger'), 0.5, {
                        transform: 'translateZ(0) translateX(0px)',
                        ease: Power2.easeOut} );

                    TweenMax.to($('.premium-links'), 0.5, {
                        transform: 'translateZ(0) translateY(0px)',
                        opacity: 1,
                        ease: Power2.easeOut} );
                }else{
                    TweenMax.to($('.logo-menu'), 0.5, {
                        transform: 'translateZ(0) translateY(-50vw)',
                        ease: Power2.easeOut} );

                    TweenMax.to($('.hamburger'), 0.5, {
                        transform: 'translateZ(0) translateX(50vw)',
                        ease: Power2.easeOut} );

                    TweenMax.to($('.premium-links'), 0.5, {
                        transform: 'translateZ(0) translateY(-100px)',
                        opacity: 0,
                        ease: Power2.easeOut} );
                }
            },


            switchMenu(){
                const _this = this;

                if(this.open == '') {
                    _this.open = 'open';
                    _this.blend = false;


                    $('main').addClass('blocked');


                    clearTimeout(_this.intBlend);
                    menuState = 1;
                //    $('main').css('pointer-events', 'none');

                    TweenMax.to($('main'), 0.3, {

                        opacity: 0.4,
                        ease: Power2.easeOut} );
                }else{
                    _this.open = '';
                    _this.intBlend =  setTimeout(function () {


                        if(_this.auxBlend){
                            _this.blend = true;
                        }
                    }, 400);
                    menuState = 0;
                    //$('main').css('pointer-events', 'auto');

                    TweenMax.to($('main'), 0.5, {

                        opacity:1,
                        ease: Power2.easeOut} );

                    $('main').removeClass('blocked');
                }

            },

            switchMenu2(){


                if(this.open == 'open') {
                    this.switchMenu();
                }

            },




            teste(){
                this.$route.path = 'teste'

                console.log( this.$route.path)
            },

            changeLang(lang) {
               // this.labels.changeLang(lang);


            },

            changePage(route) {

                this.blockMemu();

                if(this.open != ''){
                    this.switchMenu();
                }

                if(route > 4) {

                    this.$router.push(this.routes[route]);


                }else{

                    if(route == 0) {
                        this.goHome()
                    }else{
                        EVENTBUS.$emit('directAction', route - 1);

                        this.$router.push(this.routes[8]);
                    }

                }


            },



            goPage(n, hash = ''){

            console.log(n, hash, this.sub)


            const _this = this;

              _this.closeMenu();

              let route = _this.routes[n];

              if(_this.sub !== 'none'){
                route = _this.routes[n] + '#' + _this.sub;
                _this.$router.push(route);

              }else{
                _this.$router.push(route);
              }

              const url = new URL(window.location);
              url.searchParams.set('lang', this.langs[this.lang]);
              window.history.pushState({}, '', url);

            },

            

            overMenu(n, ev) {



                $('.content-menu .items a ').css('opacity', 0.7);
                $(ev.target).css('opacity', 1);
            },

            outMenu(){
                $('.content-menu .items a ').css('opacity', 1);
            },

            overBall(){
              this.ballClass = 'inover';
            },

            outBall(){

              if(this.ballClass === 'inover'){
                this.ballClass = '';

              }

            },

            openMenu(){

              const _this = this;
              this.ballClass = 'open';
               this.closeClass = 'open';


                setTimeout(function () {
                  _this.noclick = true;
                }, 100)


              let raio = (window.innerWidth / 2) + (window.innerWidth / 10);

              let del = 0.4;
              let inc = 0.03;


              _this.finishOpen = false;


              TweenMax.to($('.menu-cta-overlay'), .6, {webkitClipPath:'circle(' + raio + ' at 50vw 50vh)',  backgroundColor: '#000000', ease: Power3.easeInOut, onComplete:function() {

                }} );





                TweenMax.to($('.menu-about'), .8, {delay: del, x: 0, scaleX: 1, opacity: 1,  force3D: true, ease: "circ.out"} );
                del += inc;
                TweenMax.to($('.menu-brands'), .8, {delay:del, x: 0, scaleX: 1, opacity: 1,  force3D: true, ease: "circ.out"} );
              del += inc;
                TweenMax.to($('.menu-work'), .8, {delay: del, x: 0, scaleX: 1, opacity: 1, force3D: true, ease: "circ.out"} );
              del += inc;
            //    TweenMax.to($('.ideas-box'), .8, {delay: del, x: 0, scaleX: 1, opacity: 1, force3D: true, ease: "circ.out"} );
        //      del += inc;
                TweenMax.to($('.menu-culture'), .8, {delay: del, x: 0, scaleX: 1, opacity: 1, force3D: true, ease: "circ.out"} );
              del += inc;
                TweenMax.to($('.menu-contact'), .8, {delay: del, x: 0, scaleX: 1, opacity: 1, force3D: true, ease:"circ.out"} );

              del += inc;
                TweenMax.to($('.content-menu-item-line'), .7, {delay: del, scaleX: 1, force3D: true, ease:"circ.out"} );
              del += inc;
              TweenMax.to($('.menu-social-ico1'), .5, {delay: del, y: 0, scaleY: 1, opacity: 1, force3D: true, ease:"circ.out"} );
              del += inc;
              TweenMax.to($('.menu-social-ico2'), .5, {delay:del, y: 0, scaleY: 1, opacity: 1, force3D: true, ease:"circ.out"} );
              del += inc;
              TweenMax.to($('.menu-social-ico3'), .5, {delay: del, y: 0, scaleY: 1, opacity: 1, force3D: true, ease:"circ.out"} );
              del += inc;
              TweenMax.to($('.menu-social-ico4'), .5, {delay: del, y: 0, scaleY: 1, opacity: 1, force3D: true, ease:"circ.out"} );


              del += inc;
              TweenMax.to($('.translator'), .5, {delay: del, y: '-10vh', scaleY: 1, opacity: 1, force3D: true, ease:"circ.out"} );
              TweenMax.to($('.menu-social-ico5'), .5, {delay: del, y: 0, scaleY: 1, opacity: 1, force3D: true, ease:"circ.out", onComplete:function(){
                  setTimeout(function () {
                    _this.finishOpen = true;
                    _this.noclick = false;
                    _this.plusvis = 'vis';

                  }, 50)

                }} );




            },


            overClose(){
              this.closeClass = 'inover open';
            },
            outClose(){
              if(this.closeClass === 'inover open'){
                this.closeClass = 'open';
              }
            },
            closeMenu(){



              const _this = this;
              this.noclick = true;
              // transform: scaleY(1.1) translateY(-20px) translateZ(0); opacity: 0;
              console.log('closeMenu', _this.finishOpen)

                _this.closeClass = '';
                _this.opensub = '';
              _this.plusvis = '';
                _this.finishOpen = false;

                $('.menu-cta-label').css('pointer-events', 'none');

                TweenMax.to($('.menu-social-ico1'), .1, {delay: 0, y: '-20px', scaleY: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );
                TweenMax.to($('.menu-social-ico2'), .1, {delay: 0,y: '-20px', scaleY: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );
                TweenMax.to($('.menu-social-ico3'), .1, {delay: 0, y: '-20px', scaleY: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );
                TweenMax.to($('.menu-social-ico4'), .1, {delay: 0, y: '-20px', scaleY: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );
                TweenMax.to($('.menu-social-ico5'), .1, {delay: 0, y: '-20px', scaleY: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );
                TweenMax.to($('.content-menu-item-line'), .3, {delay: 0., scaleX: 0, force3D: true, ease:"circ.in"} );

                TweenMax.to($('.menu-contact'), 0.2, {delay: 0., x: '-50px', scaleX: 1.1, opacity: 0, force3D: true, ease: "circ.in"} );
                TweenMax.to($('.menu-culture'),  0.2, {delay: 0., x: '-50px', scaleX: 1.1, opacity:0,  force3D: true, ease: "circ.in"} );
                TweenMax.to($('.menu-work'),  0.2, {delay: 0, x: '-50px', scaleX: 1.1, opacity: 0, force3D: true, ease: "circ.in"} );
            //    TweenMax.to($('.ideas-box'),  0.2, {delay: 0, x: '-50px', scaleX: 1.1, opacity: 0, force3D: true, ease: "circ.in"} );
                TweenMax.to($('.menu-brands'),  0.2, {delay: 0, x: '-50px', scaleX: 1.1, opacity: 0, force3D: true, ease: "circ.in"} );
                TweenMax.to($('.menu-about'),  0.2, {delay: 0, x: '-50px', scaleX: 1.1, opacity: 0, force3D: true, ease:"circ.in"} );


              TweenMax.to($('.translator'), .5, {delay: 0, y: 100, scaleY: 1, opacity: 1, force3D: true, ease:"circ.in"} );

                TweenMax.to($('.menu-cta-overlay'), .4, {delay: 0.4, webkitClipPath:'circle(7px at 28px 29px)', backgroundColor: '#ff5d28',  ease: Power3.easeInOut, onComplete:function() {

                    _this.ballClass = 'after';

                    setTimeout(function () {
                      $('.menu-cta-label').css('pointer-events', 'auto');
                      _this.noclick = false;
                     // alert('fff');
                    },100);
                  }} );









            },


          overMain(s, sub = 'none'){
            this.inover = s
            this.sub = sub

            console.log( this.sub)

          },

          outMain(sub = 'none'){
            this.inover = '';


            this.sub = sub
          },


          toogleSub(){
            if(this.opensub == ''){
              this.opensub = 'opensub';
            }else{
              this.opensub = '';
            }
          }



        },
    };

</script>



// WEBPACK FOOTER //
// src/components/MenuNossa.vue